import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatDialog } from '@angular/material/dialog';
import { FrontdeskService } from '../../services/frontdesk/frontdesk.service';
import { ToastService } from '../../services/toast/toast.service';
import { PermissionService } from '../../services/permission/permission.service';
import { LoaderComponent } from '../../atoms/loader/loader.component';
import { CheckoutDialogComponent } from './checkout-dialog/checkout-dialog.component';
import { CancelDialogComponent } from '../provision-queue/cancel-dialog/cancel-dialog.component';

@Component({
  selector: 'app-frontdesk-checkout-desk',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, LoaderComponent],
  templateUrl: './frontdesk-checkout-desk.component.html',
  styleUrls: ['./frontdesk-checkout-desk.component.scss', '../../../common-style/dropdown.scss'],
})
export class FrontdeskCheckoutDeskComponent implements OnInit {
  premises = new FormControl<number | null>(null);
  date = new FormControl('');
  familyCode = new FormControl('');
  bookingId = new FormControl('');

  premisesList: any[] = [];
  groups: any[] = [];
  hasSearched: boolean = false;
  isLoading: boolean = false;
  canCheckout: boolean = false;

  constructor(
    private frontdeskService: FrontdeskService,
    private toastService: ToastService,
    private permissionService: PermissionService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.canCheckout = this.permissionService.can('checkout-desk', 'can_checkout');
    this.loadPremises();
  }

  loadPremises(): void {
    this.frontdeskService.fetchPremises().subscribe({
      next: (res: any) => (this.premisesList = res?.data || []),
      error: (err) => this.toastService.error(err?.error?.message || 'Failed to load premises.'),
    });
  }

  search(): void {
    if (!this.premises.value) {
      this.toastService.error('Select a premises.');
      return;
    }
    const payload = {
      premises: this.premises.value,
      date: this.date.value || null,
      familyCode: this.familyCode.value || null,
      bookingId: this.bookingId.value ? Number(this.bookingId.value) : null,
    };
    this.isLoading = true;
    this.frontdeskService.fetchCheckoutList(payload).subscribe({
      next: (res: any) => {
        this.groups = res?.data?.checkoutDetails || [];
        this.hasSearched = true;
        this.isLoading = false;
      },
      error: (err) => {
        this.groups = [];
        this.hasSearched = true;
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to load check-out list.');
      },
    });
  }

  checkOut(row: any): void {
    const ref = this.dialog.open(CheckoutDialogComponent, {
      width: '560px',
      maxWidth: '95vw',
      data: {
        requisitionId: row.requisitionId,
        familyCode: row.familyCode,
        name: row.primaryApplicantName,
      },
    });
    ref.afterClosed().subscribe((changed: boolean) => {
      if (changed) this.search();
    });
  }

  // only a guest still in the house can have the check-in cancelled
  canCancelCheckin(row: any): boolean {
    return this.canCheckout && (row?.fulfillmentStatus || '').toUpperCase() === 'CHECKEDIN';
  }

  // the old desk's "Cancel Check-In": cancels the whole booking with a reason
  // (the same operator cancel the queue uses; reason + remark recorded, SMS sent).
  cancelCheckin(row: any): void {
    const ref = this.dialog.open(CancelDialogComponent, {
      width: '500px',
      maxWidth: '95vw',
      data: { bookingId: row.requisitionId },
    });
    ref.afterClosed().subscribe((changed: boolean) => {
      if (changed) this.search();
    });
  }
}
